<template>
  <div v-if="!!pageReadyToDisplay">
    <div class="bg-black border-0 sm:border-b border-gray-600 report
      ">
      <div class="flex flex-col py-3 px-4">
        <div>
          <h1 class="inline-block uppercase font-medium text-lg sm:text-2xl
                   ">
            Domain Report
          </h1>
        </div>
        <div class="uppercase font-semibold tracking-widest text-xs text-gray-300">
          For Report {{ parentReportID }}
        </div>
      </div>
    </div>

    <div class="bg-black border-b border-gray-600  ">
      <div class="
        flex flex-col sm:flex-row items-stretch sm:items-center sm:justify-between
        py-3 px-4 gap-2
      ">
        <Button type="text-small"
                class="w-full sm:w-auto"
                @onClick="$router.push(
                      { name: 'executive-report',
                        params: {
                          execReport: parentReportID,
                        },
                      })">
          <template v-slot:iconLeft>
            <ArrowLeft class="text-gray-300" />
          </template>
          Back to Executive Report
        </Button>
        <Button type="primary"
                class="w-full sm:w-auto sm:ml-auto"
                @onClick="showSubdomainsModal = true">
          View all subdomains
        </Button>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5
                bg-black border-b border-gray-600
                " :class='{
                  "mb-12": !showTrialView,
                  "mb-6": showTrialView,
                }'>
      <div class="flex flex-col row-start-2 col-start-1 col-end-3 border-t
                  sm:row-start-1 sm:col-start-2 sm:border-l sm:border-t-0
                  py-3 px-4 border-gray-600   ">
        <div class="uppercase font-semibold tracking-widest text-xs text-gray-300">
          Input
        </div>
        <div>
          <span v-for="(input, index) in executiveReport.reportInput"
                :key="`input${index}`">
            {{ input }}
          </span>
        </div>
      </div>
      <div
        v-if="isSuperUser && executiveReport && executiveReport.finishedAt"
        class="flex flex-col row-start-2 col-start-3 col-end-4 border-t
                  sm:row-start-1 sm:border-t-0
                  py-3 px-4 border-gray-600

                  ">
        <div class="uppercase font-semibold tracking-widest text-xs text-gray-300">
          Runtime
        </div>
        <div>
          {{ this.executiveReport.createdAt | formatRuntime(this.executiveReport.finishedAt) }}
        </div>
      </div>
      <div v-if="isSuperUser && currentReportInitiator"
           class="flex flex-col row-start-2 col-start-4 col-end-5 border-t
                  sm:row-start-1 sm:border-t-0
                  py-3 px-4 border-gray-600">
        <div class="uppercase font-semibold tracking-widest text-xs text-gray-300">
          Initiated By:
        </div>
        <div>
          {{ currentReportInitiator }}
        </div>
      </div>
      <div v-if="isSuperUser
              && executiveReport
              && executiveReport.directoryBrutforceReturnedNoResults"
           class="flex flex-col row-start-2 col-start-5 col-end-6 border-t
                  sm:row-start-1 sm:border-t-0
                  py-3 px-4 border-red-600">
        <div class="uppercase font-semibold tracking-widest text-xs text-red-600">
          Directory Enumeration Failed
        </div>
      </div>
      <div class="flex flex-row-reverse sm:flex-row items-center border-gray-600
                  row-start-4 col-start-1 col-span-4 border-t
                  sm:row-start-1 sm:col-start-7 sm:col-span-2 sm:border-t-0">
        <div v-if="executiveReport
                   && executiveReport.pastReportDiff
                   && executiveReport.pastReportDiff.id"
             class="flex flex-col w-full py-3 px-4 border-gray-600 border-l">
          <div class="flex justify-end">
            <Checkbox id="diff-checkbox"
                      v-model="isShowingPrevious"
                      class="uppercase text-xs"
                      label="Compare with previous report" />
          </div>
          <div class="flex justify-end">
            <Button type="text-small"
                    @onClick="$router.push(
                      { name: 'executive-report',
                        params: {
                          execReport: executiveReport.pastReportDiff.id,
                        },
                      })">
              Report {{ String(executiveReport.pastReportDiff.id) | zeroPad(4) }}
              <template v-slot:iconRight>
                <ArrowRight class="text-gray-300" />
              </template>
            </Button>
          </div>
        </div>
        <div class="flex w-1/4 items-center justify-center self-stretch
                    border-l sm:w-auto
                    border-gray-600">
          <Button type="text-small"
                  class="self-stretch px-4"
                  @onClick="handleDownloadCsv">
            CSV
          </Button>
        </div>
        <div
          v-if="isSuperUser"
          class="flex w-1/4 items-center justify-center self-stretch
                    sm:border-l sm:w-auto
                    border-gray-600 ">
          <Button
            type="text-small"
            class="self-stretch px-4"
            @onClick="showAdminModal = !showAdminModal">
            <template v-slot:iconLeft>
              <Pencil class="text-gray-300" />
            </template>
            Edit
          </Button>
        </div>
      </div>
    </div>

    <div class="
      flex flex-col w-100 mb-12 text-center border border-yellow-500
      py-3 mx-4 bg-gray-900
    "  v-if="showTrialView">
      <h2 class="uppercase font-semibold tracking-widest">Trial Mode</h2>
      <p
        class="text-gray-200">
        You are seeing partial results for this report because your account is in Trial Mode.
      </p>
      <Button v-if="currentUserIsTrial" type="primary" class="self-center mt-3"
              @onClick="showSubscriptionOptions">Subscribe</Button>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-4 col-gap-4 max-w-screen-lg mx-4 lg:mx-8 mb-8">
      <div class="grid col-start-1 col-span-1 lg:col-span-3">
        <div class="w-full justify-center mb-4
                    ">
        <AttackPathwaysWrapper

          :attackPathwaysCount="attackPathways.length"
          :resolvedAttackPathwaysCount="resolvedAttackPathways.length"
          :isShowingPrevious="isShowingPrevious"
          :hasInsetHeader="true"
        >
          <template v-slot:pathways>
            <AttackPathway v-for="(attackPathway, index) in attackPathways"
                           :outcome="attackPathway.attackPathwayRule.outcome"
                           :rules="attackPathway.attackPathwayRule.rules"
                           :findings="findings"
                           :class="[
                                   {'mt-4': index !== 0},
                                 ]"
                           :newAttackPathways="newAttackPathways"
                           :domains="domains"
                           :domainId="String(currentReportID)"
                           :executiveReportID="String(parentReportID)"
                           :key="`attack-pathway-${index}`"/>
          </template>
          <template v-slot:resolvedPathways>
            <AttackPathway v-for="(attackPathway, index) in resolvedAttackPathways"
                           :outcome="attackPathway.attackPathwayRule.outcome"
                           :rules="attackPathway.attackPathwayRule.rules"
                           :findings="pastFindings"
                           :class="[
                                 {'mt-4': index !== 0},
                               ]"
                           :isResolved="true"
                           :domains="domains"
                           :domainId="String(currentReportID)"
                           :executiveReportID="String(parentReportID)"
                           :key="`resolved-attack-pathway-${index}`"/>
          </template>
        </AttackPathwaysWrapper>
        </div>
        <div class="mb-8">
          <div class="flex flex-col border border-gray-600 bg-gray-900
                       ">
            <div class="flex flex-col md:flex-row items-start md:items-center -mt-6 ml-2 mb-4">
              <h2 class="triangle relative inline-flex uppercase pl-3 pr-2 py-1 bg-gray-900
                       border-t border-l border-b border-gray-600 mr-8
                        ">
                <span class="relative inline-block z-10 text-lg sm:text-2xl">
                  DNS INTEL
                </span>
              </h2>
            </div>
            <div class="dns-intel-metrics grid grid-cols-2 lg:grid-cols-4
                        gap-x-6 gap-y-4 mx-4 pt-2 pb-4">
              <div class="flex flex-col min-w-0">
                <span class="text-3xl">{{ dnsStats.subdomains }}</span>
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  Subdomains
                </span>
              </div>
              <div class="flex flex-col min-w-0">
                <span class="text-3xl">{{ dnsStats.cnames }}</span>
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  CNAME Records
                </span>
              </div>
              <div class="flex flex-col min-w-0">
                <span class="text-3xl">{{ dnsStats.txtRecords }}</span>
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  TXT Records
                </span>
              </div>
              <div class="flex flex-col min-w-0">
                <span class="text-3xl">{{ dnsStats.txtVerificationProviders.length }}</span>
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  Discovered Vendors
                </span>
              </div>
            </div>
            <div
              class="grid grid-cols-1 xl:grid-cols-2 gap-x-8 gap-y-6 px-4 pt-4 pb-4">
              <div class="min-w-0">
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  Mail Providers
                </span>
                <div
                  v-if="dnsStats.mxHosts.length"
                  class="mt-2 dns-signal-scroll-shell"
                  :class="{ 'dns-signal-scroll-shell--active': dnsMailProvidersOverflowing }">
                  <div
                    ref="mailProvidersScrollArea"
                    class="overflow-y-scroll  dns-signal-scroll-area"
                    :class="{ 'dns-signal-scroll-area--mail': dnsMailProvidersOverflowing }">
                    <ul class="text-base leading-6 text-gray-100 break-words dns-signal-list">
                      <li v-for="host in dnsStats.mxHosts"
                          :key="host"
                          class="overflow-hidden text-ellipsis">
                        {{ host }}
                      </li>
                    </ul>
                  </div>
                </div>
                <p
v-else class="uppercase font-medium tracking-widest text-base text-gray-400 mt-2">
                  N/A
                </p>
              </div>
              <div class="min-w-0 xl:border-l border-gray-800 xl:pl-6">
                <span
class="relative inline-block z-10 uppercase font-semibold text-gray-400 block">
                  TXT Signals
                </span>
                <div
v-if="dnsStats.txtVerificationProviders.length" class="mt-2 dns-signal-scroll-shell">
                  <div
                    class="overflow-y-scroll  dns-signal-scroll-area">
                    <ul
                        class="text-base leading-6 text-gray-100 dns-signal-list"
                        :class="'dns-signal-list--tags'">
                      <li v-for="provider in dnsStats.txtVerificationProviders"
                          :key="provider.label"
                          :class="{
                            'dns-signal-provider--detailed': provider.records.length,
                          }">
                        <div>
                          {{ provider.label }}
                          <span v-if="provider.count > 1"
                                class="text-gray-400">({{ provider.count }})</span>
                        </div>
                        <ul v-if="provider.records.length"
                            class="mt-1 text-sm leading-5 text-gray-300 font-mono break-words">
                          <li v-for="record in provider.records"
                              :key="record">
                            {{ record }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <p v-else
                   class="uppercase font-medium tracking-widest text-base text-gray-400 mt-2">
                  N/A
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-start-1 lg:col-start-4 col-span-1 flex flex-col mb-8
                  ">
        <div class="mb-8">
          <Findings :findings="findings"
                    :resolvedFindings="resolvedFindings"
                    :showResolved="isShowingPrevious"/>
        </div>
        <div>
          <Summary :externalHosts="externalHosts || 0"
                   :internalHosts="internalHosts || 0"
                   :technologies="technologies"
                   :previousTechnologies="previousTechnologies"
                   :showPrevious="isShowingPrevious"
                   :isVertical="true"/>
        </div>
      </div>
    </div>
    <div class="page-break mx-4 lg:mx-8 mb-16
                max-w-screen-lg " v-if="isSuperUser && adminViewActive">
      <div class="flex flex-col border border-gray-600 bg-gray-900
                  ">
        <div class="
          flex flex-col md:flex-row items-start md:items-center -mt-6 ml-2 mb-4
        ">
          <h2 class="triangle relative inline-flex uppercase pl-3 pr-2 py-1 bg-gray-900
                   border-t border-l border-b border-gray-600 mr-8 items-center
                   ">
            <span class="relative inline-block z-10 text-lg sm:text-2xl">
              Raw Data - Admin View
            </span>
          </h2>
        </div>
        <div class="grid grid-cols-1 px-4 pt-2 pb-4">
          <div class="my-2">
            <Button type="text-small"
              class="py-2 text-gray-300 pl-2"
              @onClick="showRawErrorData = !showRawErrorData">
              {{ showOrHideByValue(showRawErrorData) }}
              Raw Error Data [{{ renderCorrectExpandElement(showRawErrorData) }}]
            </Button>
            <RawJSON
              v-if='showRawErrorData'
              :json="executiveReport.rawResponseData.errors" />
          </div>
          <div class="my-2">
            <Button type="text-small"
              class="py-2 text-gray-300 pl-2"
              @onClick="showRawTechnologyData = !showRawTechnologyData">
              {{ showOrHideByValue(showRawTechnologyData) }}
              Raw Technology Data [{{ renderCorrectExpandElement(showRawTechnologyData) }}]
            </Button>
            <RawJSON
              v-if='showRawTechnologyData'
              :json="executiveReport.rawResponseData.aggregated_result.technologies" />
          </div>
          <div class="my-2">
            <Button type="text-small"
              class="py-2 text-gray-300 pl-2"
              @onClick="showRawDNSData = !showRawDNSData">
              {{ showOrHideByValue(showRawDNSData) }}
              Raw DNS Records Data [{{ renderCorrectExpandElement(showRawDNSData) }}]
            </Button>
            <RawJSON
              v-if='showRawDNSData'
              :json="rawDnsRecords" />
          </div>
          <div class="mt-4 pl-2" v-if="executiveReport.artifacts.length > 0">
            <h3 class="
              uppercase text-gray-300 text-xs font-semibold tracking-widest
            ">
            Artifacts
            </h3>
            <div
              :key='artifact.source + executiveReport.id'
              class="" v-for="artifact in executiveReport.artifacts">
              <a :href="artifact.file" target="_blank">{{ artifact.source }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-break mx-4 lg:mx-8 mb-16
                max-w-screen-lg ">
      <div class="flex flex-col border border-gray-600 bg-gray-900
                  ">
        <div
          class="flex flex-col md:flex-row items-start md:items-start justify-between
                 -mt-6 ml-2 mb-4 mr-4 gap-3">
          <h2 class="triangle relative inline-flex uppercase pl-3 pr-2 py-1 bg-gray-900
                   border-t border-l border-b border-gray-600 mr-8 items-center
                   ">
            <LeakedCredentialsIcon
              class="mr-1 " />
            <span class="relative inline-block z-10 text-lg sm:text-2xl">
              Leaked Credentials [{{ credentialsCount }}]
            </span>
          </h2>
          <button
            v-if="credentialsCount && (!noNewCreds || showLeakedCredsAnyway)"
            type="button"
            class="triangle export-creds-chip relative inline-flex uppercase pl-3 pr-2 py-1
                   bg-gray-900 border-t border-l border-b border-gray-600 items-center
                   self-end md:self-auto mt-6 md:mt-1 text-xs tracking-widest"
            @click="handleDownloadLeakedCredsCsv">
            <span class="relative inline-block z-10 text-gray-300">Export creds</span>
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 px-4 pt-2 pb-4">
          <template v-if="credentialsCount && (!noNewCreds || showLeakedCredsAnyway)">
            <div v-if='executiveReport.summary.leakedCredentialsSummary["2"] >= 1'
                 class="md:mr-2">
              <LeakedCredentialsList
                class="mb-4"
                :credentials="credentialsCritical"
                :defaultRowCount="credentialsCritical && credentialsCritical.length"
                :threatLevel="2"
                :isTrial='showTrialView'
                :trialCount='executiveReport.summary.leakedCredentialsSummary["2"]'
              />
            </div>
            <div class="md:ml-2">
              <LeakedCredentialsList
                v-if='executiveReport.summary.leakedCredentialsSummary["1"] >= 1'
                class="mb-8"
                :credentials="credentialsMedium"
                :defaultRowCount="credentialsMedium && credentialsMedium.length"
                :threatLevel="1"
                :isTrial='showTrialView'
                :trialCount='executiveReport.summary.leakedCredentialsSummary["1"]'
              />
              <LeakedCredentialsList
                v-if='executiveReport.summary.leakedCredentialsSummary["0"] >= 1'
                :credentials="credentialsLow"
                :defaultRowCount="credentialsLow && credentialsLow.length"
                :threatLevel="0"
                :isTrial='showTrialView'
                :trialCount='executiveReport.summary.leakedCredentialsSummary["1"]'
              />
            </div>
          </template>
          <template v-else-if="credentialsCount && noNewCreds">
            <div class="px-4 pt-4 pb-8 text-center col-span-2">
              <h2 class="uppercase font-medium tracking-widest text-lg text-gray-200">
                No New Leaked Credentials Discovered
              </h2>
              <div class="mt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Button
                  type="text-small"
                  class="px-4"
                  @onClick="showLeakedCredsAnyway = true">
                  Show Anyway
                </Button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="px-4 pt-4 pb-8 text-center col-span-2">
              <h2 class="uppercase font-medium tracking-widest text-lg text-gray-200">
                No Leaked Credentials Discovered
              </h2>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="page-break  grid col-gap-3 row-gap-4 grid-cols-1 xl:grid-cols-7
                mx-4 lg:mx-8 mb-16
                max-w-screen-lg  ">
      <div class="flex flex-col row-start-1 col-start-1 border border-gray-600 bg-gray-900
                  xl:col-start-1 xl:col-span-6
                   ">
        <div class="
          flex flex-col lg:flex-row items-start lg:items-center -mt-6 ml-2 mb-4

        ">
          <h2 ref="hostsSection"
              class="triangle relative inline-flex uppercase pl-3 pr-2 py-1 bg-gray-900
                   border-t border-l border-b border-gray-600 mr-8

                   ">
            <span class="relative inline-block z-10 text-lg sm:text-2xl">
              Hosts Found [
                {{ executiveReport.summary.hostSummary.total }}
              ]
            </span>
          </h2>
          <div class="flex flex-col items-start ml-4 mt-4
                      sm:flex-row sm:items-center lg:ml-0 lg:mt-0

                      ">
            <RadioButton id="filter1" label="All" value="All" name="filters"
                         v-model="findingsFilter"
                         class="mr-2"/>
            <RadioButton id="filter2"
                         :label="
                          `With Findings [${executiveReport.summary.hostSummary.withFindings}]`
                         "
                         value="Findings"
                         name="filters"
                         v-model="findingsFilter"
                         class="mr-2 mt-2 sm:mt-0"/>
            <RadioButton id="filter3"
                         :label="
                          `Without Findings [${
                            executiveReport.summary.hostSummary.withoutFindings
                            }]`
                          "
                         value="No Findings"
                         name="filters"
                         v-model="findingsFilter"
                         class="mt-2 sm:mt-0 mr-2"/>
            <RadioButton id="filter4"
                         :label="
                          `Screenshots [${
                            executiveReport.summary.screenshotCount
                            }]`
                          "
                         value="Screenshots"
                         name="filters"
                         v-model="findingsFilter"
                         class="mt-2 sm:mt-0"/>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row
        xl:hidden justify-between px-4 mb-4 mt-2
                     ">
          <FilterFinding v-model="filteredFindings"
                         class="w-full mb-2 sm:mb-0 sm:mr-2"
                         :findings="findings"/>
          <FilterTechnology v-model="filteredTechnologies"
                            class="w-full mb-2 sm:mb-0 sm:ml-2 sm:mr-2"
                            :technologies="technologies"/>
          <div class="w-full sm:ml-2 ">
            <div class="flex flex-col bg-gray-900 border border-gray-600 p-4
                        w-full">
              <Button type="secondary" class="mb-4" @onClick="expandAllHosts">
                Expand All Hosts
              </Button>
              <Button type="secondary" @onClick="collapseAllHosts">
                Collapse All Hosts
              </Button>
            </div>
          </div>
        </div>
        <div v-if="isSuperUser" class="px-4 pb-4 ">
          <label class="uppercase font-semibold tracking-widest text-xs text-gray-300">
            Additional Directory Enumeration
          </label>
          <div class="uppercase text-medium font-semibold">
            <div v-if="!executiveReport.manualDirectoryEnumerationStatus"
                 class="text-gray-200">
              Not Started
            </div>
            <div v-if="executiveReport.manualDirectoryEnumerationStatus === 'in_flight'"
                 class="text-white-500">
              In Progress
            </div>
            <div v-if="executiveReport.manualDirectoryEnumerationStatus === 'completed'"
                 class="text-green-500">
              Completed
            </div>
            <div v-if="executiveReport.manualDirectoryEnumerationStatus === 'failed'"
                 class="text-red-500">
              Failed
            </div>
            <div v-if="executiveReport.manualDirectoryEnumerationTimestamp"
                class="tracking-widest text-xs text-gray-300">
              {{ executiveReport.manualDirectoryEnumerationTimestamp | formatTimestamp }}
            </div>
          </div>
        </div>
        <div class="grid grid-cols-5 xl:grid-cols-5 mb-4 mt-2  xl:pr-32
                    "
             :class="{
               'flex-grow': filteredHosts.length === 0 && findingsFilter !== 'Screenshots'
             }"
             id="hosts-container">
          <masonry class="col-span-5 xl:col-span-5 "
                   :cols="{default: 2, 400: 1}">
            <Host class="col-span-5 xl:col-span-4 mb-2 mx-4 "
                  v-for="(host, index) in paginatedFilteredHosts"
                  :id="hostAnchorId(host)"
                  @dirEnumTargetUpdated="updateDirEnumTargets"
                  @showPortScreenshots="showPortScreenshots"
                  :rootDomain="domains[0] && domains[0].name"
                  :reportId="currentReportID"
                  :isSuperuser="currentUser && currentUser.isSuperuser"
                  :targetsForDictEnum="targetsForDictEnum"
                  :rawData='rawDataForHostByIPAddress(host.ip)'
                  :ip="host.ip || ''"
                  :category="host.category || ''"
                  :categoryExplanation="host.categoryExplanation || ''"
                  :country="host.country || ''"
                  :asn="host.asn || ''"
                  :org="host.org || ''"
                  :subdomains="host.subdomains"
                  :technologies="host.technologies"
                  :ports="host.ports"
                  :screenshots="host.screenshots || []"
                  :findings="host.findings.rules"
                  :forceExpand="expandAll"
                  :highlighted="highlightedHostIp === host.ip"
                  :key="`host-${index}}`"/>

          </masonry>
          <div ref="observed" class="col-span-5 h-1 "></div>

          <div v-if="isShowingPrevious && (removedHosts.length > 0 || filteredHosts.length > 0)"
               class="grid xl:grid-cols-6 col-span-6 mb-2
               border-t  border-gray-600 pt-6 mt-8">
            <div class="col-span-5 flex -mt-12 w-full justify-center mb-4">
              <h2 class="relative inline-flex uppercase px-4 py-1 bg-gray-900
                         border border-gray-600 transform skew-x-20 max-h-12 header-wrapper">
                <span class="
                  relative inline-block z-10 text-2xl transform -skew-x-20 header-wrapper
                ">
                  Removed Hosts [{{ removedHosts.length }}]
                </span>
              </h2>
            </div>
            <div v-if="showRemovedHosts" class="col-span-5 mx-4">
              <masonry class="col-span-5 xl:col-span-5 "
                       :cols="{default: 2, 400: 1}">
                <Host class="col-span-5 xl:col-span-4 mb-2 mx-4 "
                      v-for="(host, index) in removedHosts"
                      :id="hostAnchorId(host)"
                      @showPortScreenshots="showPortScreenshots"
                      :rawData='rawDataForHostByIPAddress(host.ip)'
                      :reportId="currentReportID"
                      :ip="host.ip || ''"
                      :category="host.category || ''"
                      :categoryExplanation="host.categoryExplanation || ''"
                      :country="host.country || ''"
                      :asn="host.asn || ''"
                      :org="host.org || ''"
                      :subdomains="host.subdomains"
                      :technologies="host.technologies"
                      :ports="host.ports"
                      :screenshots="host.screenshots || []"
                      :findingsCount="host.findings.count"
                      :findings="host.findings.rules"
                      :forceExpand="expandAll"
                      :highlighted="highlightedHostIp === host.ip"
                      :key="`removed-host-${index}}`"/>
              </masonry>

            </div>
            <Button type="text-small"
                    class="col-span-5 w-full py-4 text-gray-300"
                    @onClick="showRemovedHosts = !showRemovedHosts">
              {{ showRemovedHosts ? 'Hide' : 'Show' }}
              <template v-slot:iconRight>
                <Chevron class="text-gray-200 transform
                    transition-transform duration-200 linear"
                         :class="{'-rotate-180': showRemovedHosts}"/>
              </template>
            </Button>
          </div>
          <div v-if="findingsFilter !== 'Screenshots'">
            <p v-if="(!isShowingPrevious
                && filteredHosts.length === 0)
                || (isShowingPrevious
                && removedHosts.length === 0
                && filteredHosts.length === 0)"
               class="flex justify-center items-center uppercase font-medium tracking-widest text-lg
             text-gray-200 text-center mt-4 mb-8 col-span-5">
              No Hosts to Display
            </p>
          </div>
          <div v-show="findingsFilter === 'Screenshots'" class="col-span-5 mx-4">
            <Button
              v-if="activeScreenshotHostIp && activeScreenshotGroupVisible"
              type="secondary"
              class="screenshot-return-button "
              @onClick="returnToActiveScreenshotHost">
              <template v-slot:iconLeft>
                <ArrowLeft class="screenshot-return-icon text-gray-300" />
              </template>
              <span class="flex flex-col items-start leading-tight">
                <span>Back to Host</span>
                <span class="screenshot-return-detail hidden md:block text-xs
                             text-gray-300 normal-case">
                  screenshots for: {{ activeScreenshotHostIp }}
                </span>
                <span class="screenshot-return-detail md:hidden text-gray-300 normal-case">
                  {{ activeScreenshotHostIp }}
                </span>
              </span>
            </Button>
            <div
                ref="screenShotContainer"
                id="screen-shot-container"
                class="grid col-gap-3 row-gap-4 grid-cols-1
      md:grid-cols-4  ml-3 mr-4 mb-4 mt-2">
              <div v-for="(screenshot, index) in screenshots"
                   :id="screenshotAnchorId(screenshot)"
                   :key="`screenshot-${index}`"
                   class="border px-1 pt-1"
                   :class="screenshotCardClass(screenshot)">
                <a :href="screenshot.file"
                   target="_blank"
                   rel="noopener noreferrer"
                   class="screenshot-image-frame">
                  <img :src="screenshot.file"
                       :alt="screenshotAltText(screenshot)"
                       loading='lazy'/>
                </a>
                <div class="flex flex-col my-3">
                  <p v-if="screenshot.domainName"
                     class="text-white text-sm text-center font-semibold tracking-wider break-all"
                     @mousedown.left="beginScreenshotCaptionSelection($event)">
                    <button type="button"
                            class="screenshot-caption-button"
                            @click="showHostFromScreenshot(screenshot, $event)">
                      <span class="screenshot-caption-text">{{ screenshot.domainName }}</span>
                    </button>
                  </p>
                  <p v-if="screenshot.ipAddress && screenshot.port"
                     class="text-white text-sm text-center font-semibold tracking-wider break-all"
                     @mousedown.left="beginScreenshotCaptionSelection($event)">
                    <button type="button"
                            class="screenshot-caption-button"
                            @click="showHostFromScreenshot(screenshot, $event)">
                      <span
                        class="screenshot-caption-text"
                        v-text="`${screenshot.ipAddress}:${screenshot.port}`"></span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <div ref="screenshotObserved" class="h-1 "></div>
          </div>

        </div>
        <div class="grid grid-cols-5 xl:grid-cols-6 mb-4 mt-2
                    "
              v-if="showTrialView && filteredHosts.length > 0">
          <p class="
            italic text-center col-span-5 text-gray-300
          " v-if='executiveReport.summary.hostSummary.total > 1'>
            We found a total of {{ executiveReport.summary.hostSummary.total }}
            {{ 'host' | pluralize(executiveReport.summary.hostSummary.total) }},
            upgrade to see them all.
          </p>
          <p class='italic text-center col-span-5 text-gray-300' v-else>
            Upgrade to see all discovered hosts.
          </p>
        </div>
      </div>
      <div class="hidden xl:flex flex-col col-span-2 col-start-6 row-start-1 -mt-4 xl:pl-16
                  ">
        <FilterFinding v-model="filteredFindings"
                       class="mb-3"
                       :findings="findings"/>
        <FilterTechnology v-model="filteredTechnologies"
                          class="mb-3"
                          :technologies="technologies"/>
        <div class="flex flex-col justify-between bg-gray-900 border
         border-gray-600 p-4 mb-3 ">
          <Button type="secondary" class="mb-4" @onClick="expandAllHosts">
            Expand All Hosts
          </Button>
          <Button type="secondary" @onClick="collapseAllHosts">
            Collapse All Hosts
          </Button>
        </div>
      </div>
    </div>
    <AdminModal

      v-if="showAdminModal"
      :reportId='Number(parentReportID)'
      :findings="findingsAll"
      :attackPathwayFindings="attackPathwaysAll"
      :parentReportID="String(parentReportID)"
      @close='handleClose'
      @recollated='handleRecollated'
      />

    <ReportActionBar
      v-if="(targetsForDictEnum && targetsForDictEnum.length)
      || requestDirectoryEnumerationStatus"
      @cancelAction="clearHostsForDictEnum"
      @submitAction="requestDictEnum"
      :requestStatus="requestDirectoryEnumerationStatus"
      :targets="targetsForDictEnum"
      />

    <SubdomainsModal
      v-if="executiveReport"
      :executiveReport="executiveReport"
      :reportId="String(currentReportID)"
      :show="showSubdomainsModal"
      @close="showSubdomainsModal = false"
    />

  </div>

  <div v-else-if="(!isLoading && !pendingRequestCount) && isFailed"
       class="flex justify-center items-center my-12 max-w-screen-lg
              ">
    <ReportErrorMessage key="failed">
      <template v-slot:main>
        Report {{ String(currentReportID) | zeroPad(4) }} Failed
      </template>
      <template v-slot:additional>
        <template v-if="executiveReport.hasErrors">
          [ Errors Encountered ]
        </template>
        <template v-if="showNotAcceptingWebTraffic">
          [ Not Accepting Web Traffic ]
        </template>
      </template>
    </ReportErrorMessage>
  </div>
  <div v-else-if="executiveReportLoadStatus === 'missing'"
       class="flex justify-center items-center my-12 max-w-screen-lg
              ">
    <ReportErrorMessage key="missing">
      <template v-slot:main>
        Report Missing
      </template>
    </ReportErrorMessage>
  </div>
  <div v-else-if="(!isLoading && !pendingRequestCount) && isInFlight"
       class="flex flex-grow items-start justify-end">
    <ProgressReport class="w-full mx-8 md:w-5/12 md:mt-16"
                    :step="executiveReport && executiveReport.progress || 0"
                    :is-recollating="isRecollating" />
  </div>
  <div v-else-if="executiveReportLoadStatus === 'unavailable'"
       class="flex flex-grow items-start fade-in">
    <div class="w-full mx-8 md:w-5/12 md:mt-32 text-center">
      <h2 class="uppercase text-2xl mb-2">
        Reconnecting...
      </h2>
      <p class="text-gray-100">
        Report data is temporarily unavailable. Retrying automatically.
      </p>
    </div>
  </div>
  <div v-else-if="!pageReadyToDisplay"
       class="flex flex-grow items-start fade-in">
    <div
        class="relative top-0 left-0 w-full h-full">
      <div class="background-wrapper background-wrapper--step2">
        <BackgroundImage class="background" />
      </div>
    </div>
    <div class="w-full mx-8 md:w-5/12 md:mt-32 text-center">
      <h2 class="uppercase text-2xl mb-2">
        Loading...
      </h2>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ArrowLeft from '@/assets/arrow_left.svg?inline';
import ArrowRight from '@/assets/arrow_right.svg?inline';
import AttackPathway from '@/components/AttackPathway.vue';
import BackgroundImage from '@/assets/new-report-bg.svg?inline';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import Findings from '@/components/Findings.vue';
import Summary from '@/components/Summary.vue';
import Chevron from '@/assets/chevron.svg?inline';
import RadioButton from '@/components/RadioButton.vue';
import Host from '@/components/Host.vue';
import FilterFinding from '@/components/FilterFinding.vue';
import FilterTechnology from '@/components/FilterTechnology.vue';
import AttackPathwaysWrapper from '@/components/AttackPathwaysWrapper.vue';
import ReportActionBar from '@/components/ReportActionBar.vue';
import ReportErrorMessage from '@/components/ReportErrorMessage.vue';
import LeakedCredentialsIcon from '@/assets/asterisk.svg?inline';
import LeakedCredentialsList from '@/components/LeakedCredentialsList.vue';
import AdminModal from '@/components/AdminModal.vue';
import Pencil from '@/assets/pencil.svg?inline';
import ProgressReport from '@/components/ProgressReport.vue';
import RawJSON from '@/components/Admin/RawJSON.vue';
import api from '@/store/api';
import SubdomainsModal from '@/components/SubdomainsModal.vue';

export default {
  name: 'DomainReport',
  components: {
    AdminModal,
    ArrowLeft,
    ArrowRight,
    AttackPathway,
    AttackPathwaysWrapper,
    BackgroundImage,
    Button,
    Checkbox,
    Chevron,
    FilterFinding,
    FilterTechnology,
    Findings,
    Host,
    LeakedCredentialsIcon,
    LeakedCredentialsList,
    Pencil,
    ProgressReport,
    RadioButton,
    RawJSON,
    ReportActionBar,
    ReportErrorMessage,
    Summary,
    SubdomainsModal,
  },
  data() {
    return {
      showAdminModal: false,
      pollingCount: 0,
      pollingTimeout: null,
      hosts: [],
      isShowingPrevious: false,
      showResolvedPathways: true,
      showRemovedHosts: true,
      findingsFilter: 'Findings',
      filteredFindings: [],
      filteredTechnologies: [],
      pastHosts: [],
      expandAll: false,
      observer: null,
      screenShotObserver: null,
      activeScreenshotVisibilityObserver: null,
      activeScreenshotVisibilityHandler: null,
      shouldScrollToHosts: false,
      showRawErrorData: false,
      showRawTechnologyData: false,
      showRawDNSData: false,
      targetsForDictEnum: [],
      page: 0,
      screenShotPage: 0,
      activeScreenshotHostIp: null,
      activeScreenshotTargetLabel: null,
      activeScreenshotGroupVisible: false,
      highlightedHostIp: null,
      previousFindingsFilter: null,
      screenshotCaptionSelectionCleanup: null,
      showSubdomainsModal: false,
      showLeakedCredsAnyway: false,
      dnsMailProvidersOverflowing: false,
    };
  },
  async mounted() {
    window.addEventListener('resize', this.updateDnsMailProvidersOverflowState);
    await this.loadCurrentReport();
    this.updateDnsMailProvidersOverflowState();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDnsMailProvidersOverflowState);
    clearTimeout(this.pollingTimeout);
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.screenShotObserver) {
      this.screenShotObserver.disconnect();
    }

    this.teardownActiveScreenshotVisibilityObserver();
    if (this.screenshotCaptionSelectionCleanup) {
      this.screenshotCaptionSelectionCleanup();
    }
  },
  computed: {
    ...mapGetters([
      'noNewCreds',
      'executiveReport',
      'executiveReportLoadStatus',
      'reportScreenshots',
      'adminViewActive',
      'selectedView',
      'isLoading',
      'pastReport',
      'pastScreenshots',
      'isSuperUser',
      'pendingRequestCount',
      'filterFindingEvent',
      'rawDataForHostByIPAddress',
      'requestDirectoryEnumerationStatus',
      'currentUser',
      'currentReportInitiator',
    ]),
    domains() {
      if (!this.executiveReport) return [];
      const domains = [];
      try {
        this.executiveReport.children.forEach((child) => {
          domains.push({
            id: child.id,
            name: child.reportInput[0],
            findingsCount: child.findings ? child.findings.length : 0,
            attackPathwaysCount: child.attackPathwayFindingsCount,
            screenshots: child.screenshots,
          });
        });
      } catch (e) {
        // Swallow parsing errors so we can fall back to the executive report data.
      }

      if (domains && domains.length === 0) {
        domains.push({
          id: this.executiveReport.id,
          name: this.executiveReport.reportInput[0],
          findingsCount: this.executiveReport.findings ? this.executiveReport.findings.length : 0,
          attackPathwaysCount: this.executiveReport.summary.attackPathwaysCount,
          screenshots: this.executiveReport.screenshots,
        });
      }
      return domains;
    },
    isInFlight() {
      return this.isCurrentReport && this.executiveReport.status === 'in_flight';
    },
    isRecollating() {
      return this.isInFlight && Boolean(this.executiveReport.finishedAt);
    },
    isFailed() {
      return this.isCurrentReport && this.executiveReport.status === 'failed';
    },
    showNotAcceptingWebTraffic() {
      return Boolean(this.executiveReport)
        && this.executiveReport.isAcceptingWebTraffic === false;
    },
    isCompleted() {
      return this.isCurrentReport && this.executiveReport.status === 'completed';
    },
    showTrialView() {
      return (this.selectedView === 'customer'
        && this.executiveReport.initiatedBy.organization.isTrial) || this.currentUserIsTrial;
    },
    currentUserIsTrial() {
      return Boolean(this.currentUser.organization && this.currentUser.organization.isTrial);
    },
    currentReportID() {
      return this.$route.params.domainReport;
    },
    isCurrentReport() {
      return this.executiveReport
        && String(this.executiveReport.id) === String(this.currentReportID);
    },
    newAttackPathways() {
      if (this.executiveReport
        && this.executiveReport.pastReportDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0]
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemAdded) {
        // eslint-disable-next-line max-len
        const added = this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemAdded;
        const attackPathKeys = Object.keys(added).filter((key) => key.includes('attackPathwayFindings'));
        return attackPathKeys
          .map((key) => added[key])
          .filter((pathway) => pathway
            && pathway.attackPathwayRule
            && Array.isArray(pathway.attackPathwayRule.rules));
      }
      return [];
    },
    pastReportID() {
      return this.executiveReport
        && this.executiveReport.pastReportDiff
        && this.executiveReport.pastReportDiff.id;
    },
    parentReportID() {
      return this.$route.params.execReport;
    },
    pollingInterval() {
      let interval = 10000; // 10 seconds

      // Over one minute
      if (this.pollingCount > 5) {
        interval = 30000; // 30 seconds
      }

      // Over 3 minutes
      if (this.pollingCount > 9) {
        interval = 60000; // 1 minute
      }

      // Over 10 minutes
      if (this.pollingCount > 16) {
        interval = 300000; // 5 minutes
      }

      return interval;
    },
    findings() {
      const { domains } = this;
      const domainsForFindings = domains.map((d) => ({ domain: d.name, reportId: d.id }));
      return (this.executiveReport
             && this.executiveReport.aggregatedResult
             && this.executiveReport.aggregatedResult.findings
               .filter((finding) => finding.visible)
               .map((f) => ({ ...f, domains: domainsForFindings }))) ?? [];
    },
    findingsAll() {
      return this.executiveReport
        && this.executiveReport.aggregatedResult
        && this.executiveReport.aggregatedResult.findings;
    },
    pastFindings() {
      return (this.pastReport
        && this.pastReport.aggregatedResult
        && this.pastReport.aggregatedResult.findings)
        || (this.pastReport
          && this.pastReport.executiveSummary
          && this.pastReport.executiveSummary.findings);
    },
    resolvedFindings() {
      if (this.executiveReport
        && this.executiveReport.pastReportDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0]
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved) {
        // eslint-disable-next-line max-len
        const removed = this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved;
        const findingsKeys = Object.keys(removed).filter((key) => key.includes('findings'));
        const findingsArray = [];
        findingsKeys.forEach((key) => findingsArray.push(removed[key]));
        return findingsArray;
      }
      return [];
    },
    externalHosts() {
      return (this.executiveReport.executiveSummary
              && this.executiveReport.executiveSummary.externalIpsCount)
              || this.executiveReport.summary.externalIpsCount;
    },
    internalHosts() {
      return (this.executiveReport.executiveSummary
              && this.executiveReport.executiveSummary.internalIpsCount)
              || this.executiveReport.summary.internalIpsCount;
    },
    technologies() {
      return (this.executiveReport.executiveSummary
              && this.executiveReport.executiveSummary.technologies)
              || this.executiveReport.summary.technologies;
    },
    previousTechnologies() {
      if (this.executiveReport
        && this.executiveReport.pastReportDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0]
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved) {
        // eslint-disable-next-line max-len
        const removed = this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved;
        const techKeys = Object.keys(removed).filter((key) => key.includes('technologies'));
        const techArray = [];
        techKeys.forEach((key) => techArray.push(removed[key]));
        return techArray;
      }
      return [];
    },
    attackPathways() {
      return (this.executiveReport
          && this.executiveReport.aggregatedResult
          && this.executiveReport.aggregatedResult.attackPathwayFindings
            .filter((finding) => finding.visible)) ?? [];
    },
    attackPathwaysAll() {
      return this.executiveReport
        && this.executiveReport.aggregatedResult
        && this.executiveReport.aggregatedResult.attackPathwayFindings;
    },
    dnsStats() {
      const stats = {
        subdomains: 0,
        cnames: 0,
        txtRecords: 0,
        mxHosts: [],
        txtVerificationProviders: [],
      };
      if (!this.executiveReport) {
        return stats;
      }
      const aggregated = this.executiveReport.aggregatedResult || {};
      const subdomainSet = new Set();
      if (Array.isArray(aggregated.ips)) {
        aggregated.ips.forEach((host = {}) => {
          if (Array.isArray(host.subdomains)) {
            host.subdomains.forEach((sd) => {
              if (sd) subdomainSet.add(sd);
            });
          }
        });
      }
      stats.subdomains = subdomainSet.size;
      const dnsRecords = aggregated.dnsRecords
        || (this.executiveReport.rawResponseData
          && this.executiveReport.rawResponseData.aggregated_result
          && this.executiveReport.rawResponseData.aggregated_result.dns_records)
        || [];
      const mxSet = new Set();
      const txtProviderCounts = {};
      const txtProviderRecords = {};
      const normalizeMxValue = (value) => {
        if (!value) return null;
        return String(value).replace(/^\s*\d+\s+/, '').trim() || null;
      };
      const txtSignalMatchers = [
        { label: 'SPF', patterns: ['v=spf1', 'spf2.0/'] },
        { label: 'Google', patterns: ['google-site-verification'] },
        { label: 'Apple', patterns: ['apple-domain-verification'] },
        { label: 'Atlassian', patterns: ['atlassian-domain-verification', 'atlassian-sending-domain-verification'] },
        { label: 'Facebook', patterns: ['facebook-domain-verification', 'workplace-domain-verification'] },
        { label: 'Microsoft', patterns: ['ms=', 'mscid=', 'ms-domain-verification', 'msfpkey', 'd365mktkey', 'onmicrosoft.com'] },
        { label: 'OpenAI', patterns: ['openai-domain-verification'] },
        { label: 'Anthropic', patterns: ['anthropic-domain-verification'] },
        { label: 'Cursor', patterns: ['cursor-domain-verification'] },
        { label: 'Perplexity', patterns: ['perplexity-ai-domain-verification'] },
        { label: 'Mistral', patterns: ['mistral-domain-verification'] },
        { label: 'Google Workspace', patterns: ['google-gws-recovery-domain-verification'] },
        { label: 'Zoom', patterns: ['zoom_verify_', 'zoom-domain-verification', 'zoom-verification'] },
        { label: 'DocuSign', patterns: ['docusign=', 'docusign'] },
        { label: 'Box', patterns: ['box-domain-verification'] },
        { label: 'Duo', patterns: ['duo_sso_verification'] },
        { label: 'Jamf', patterns: ['jamf-site-verification'] },
        { label: 'Airtable', patterns: ['airtable-verification'] },
        { label: 'Censys', patterns: ['censys-domain-verification'] },
        { label: 'OneTrust', patterns: ['onetrust-domain-verification'] },
        { label: 'Smartsheet', patterns: ['smartsheet-site-validation'] },
        { label: 'Docker', patterns: ['docker-verification'] },
        { label: 'Miro', patterns: ['miro-verification'] },
        { label: 'Slack', patterns: ['slack-domain-verification'] },
        { label: 'Stripe', patterns: ['stripe-verification'] },
        { label: 'Canva', patterns: ['canva-site-verification'] },
        { label: 'Cisco', patterns: ['cisco-ci-domain-verification'] },
        { label: 'Notion', patterns: ['notion-domain-verification', 'notion_verify_'] },
        { label: 'GlobalSign', patterns: ['_globalsign-domain-verification', 'globalsign-domain-verification'] },
        { label: 'MongoDB', patterns: ['mongodb-site-verification'] },
        { label: 'Dynatrace', patterns: ['dynatrace-site-verification'] },
        { label: 'Mixpanel', patterns: ['mixpanel-domain-verify'] },
        { label: 'HubSpot', patterns: ['hubspot-domain-verification', 'hubspot-developer-verification'] },
        { label: 'Twilio', patterns: ['twilio-domain-verification'] },
        { label: 'Yahoo', patterns: ['yahoo-verification-key'] },
        { label: 'ElevenLabs', patterns: ['elevenlabs'] },
        { label: 'Klaviyo', patterns: ['klaviyo-site-verification'] },
        { label: 'LogMeIn', patterns: ['logmein-verification-code'] },
        { label: '1Password', patterns: ['1password-site-verification'] },
        { label: 'Adobe', patterns: ['adobe-idp-site-verification', 'adobe-sign-verification', 'adobe-aem-verification'] },
        { label: 'Ahrefs', patterns: ['ahrefs-site-verification'] },
        { label: 'Cloudflare', patterns: ['cloudflare_dashboard_sso'] },
        { label: 'Dropbox', patterns: ['dropbox-domain-verification'] },
        { label: 'HackerOne', patterns: ['h1-domain-verification'] },
        { label: 'KnowBe4', patterns: ['knowbe4-site-verification'] },
        { label: 'Loom', patterns: ['loom-site-verification', 'loom-verification'] },
        { label: 'Mailgun', patterns: ['mgverify'] },
        { label: 'Autodesk', patterns: ['autodesk-domain-verification'] },
        { label: 'Have I Been Pwned', patterns: ['have-i-been-pwned-verification'] },
        { label: 'Linear', patterns: ['linear-domain-verification'] },
        { label: 'LiveRamp', patterns: ['liveramp-site-verification'] },
        { label: 'Palo Alto Networks', patterns: ['paloaltonetworks-site-verification', 'panw-email-dlp-verification'] },
        { label: 'Zoho', patterns: ['zoho-verification'] },
        { label: 'Amazon SES', patterns: ['amazonses:'] },
        { label: 'Brevo', patterns: ['brevo-code:', 'sendinblue-code:'] },
        { label: 'Mandrill', patterns: ['mandrill_verify.'] },
        { label: 'Salesforce Marketing Cloud', patterns: ['sfmc-'] },
        { label: 'Pardot', patterns: ['pardot', 'sending_domain'] },
        { label: 'Fastly', patterns: ['fastly-domain-delegation'] },
        { label: 'VMware Cloud', patterns: ['vmware-cloud-verification'] },
        { label: 'Webex', patterns: ['webexdomainverification'] },
        { label: 'TeamViewer', patterns: ['teamviewer-sso-verification'] },
        { label: 'TikTok', patterns: ['tiktok-developers-site-verification', 'tiktok-domain-verification', 'tiktok-verification'] },
        { label: 'BrowserStack', patterns: ['browserstack-domain-verification'] },
        { label: 'LaunchDarkly', patterns: ['launchdarkly-domain-verification'] },
        { label: 'Tenderly', patterns: ['tenderly-domain-verification'] },
        { label: 'GitKraken', patterns: ['gitkraken-domain-verification'] },
        { label: 'Gitpod', patterns: ['gitpod-verification'] },
        { label: 'ProdPad', patterns: ['prodpad-domain-verification'] },
        { label: 'Qase', patterns: ['qase-'] },
        { label: 'Rippling', patterns: ['rippling-domain-verification'] },
        { label: 'Secureframe', patterns: ['secureframe-domain-verification'] },
        { label: 'Read AI', patterns: ['read-ai-verification'] },
        { label: 'Wrike', patterns: ['wrike-verification'] },
        { label: 'Zeplin', patterns: ['zeplin'] },
        { label: 'WalletConnect', patterns: ['wallet-connect-dns-verification'] },
        { label: 'Flexera', patterns: ['flexera-domain-verification'] },
        { label: 'Tollbit', patterns: ['tollbit-domain-verification'] },
        { label: 'InfoBlox', patterns: ['infoblox-domain-mastery'] },
        { label: 'LucidLink', patterns: ['lucidlink-verification'] },
        { label: 'Webex', patterns: ['webexdomainverification'] },
      ];
      const titleizeSignalLabel = (value) => value.split(/[-_.]+/)
        .filter(Boolean)
        .map((part) => {
          const upperAliases = {
            ai: 'AI',
            aws: 'AWS',
            afd: 'AFD',
            dns: 'DNS',
            hcp: 'HCP',
            hpe: 'HPE',
            idp: 'IDP',
            ses: 'SES',
            sso: 'SSO',
          };
          const lower = part.toLowerCase();
          if (upperAliases[lower]) return upperAliases[lower];
          return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(' ');
      const inferGenericTxtSignal = (value) => {
        let candidate = String(value || '')
          .replace(/\\u003d/g, '=')
          .replace(/"/g, '')
          .toLowerCase()
          .trim();
        if (!candidate || candidate.includes('://')) return null;
        if (candidate.includes('@')) return null;
        if (!/(verification|validation|verify|challenge)/.test(candidate)
          && !/(^|[-_.])domainverification/.test(candidate)) {
          return null;
        }
        if (/\b(?:\.com|\.net|\.org|\.io|\.gov|\.edu|\.co|\.ai|\.us)\b/.test(candidate)) {
          return null;
        }
        candidate = candidate.replace(/^_+/, '');
        candidate = candidate.replace(/[:=].*$/, '');
        candidate = candidate.replace(/(?:-domain|-site)?-verification(?:-[a-z0-9]+)?$/, '');
        candidate = candidate.replace(/(?:-domain|-site)?-validation(?:-[a-z0-9]+)?$/, '');
        candidate = candidate.replace(/(?:-domain|-site)?-verify(?:-[a-z0-9]+)?$/, '');
        candidate = candidate.replace(/(?:-domain|-site)?-challenge(?:-[a-z0-9]+)?$/, '');
        candidate = candidate.replace(/domainverification$/i, '');
        candidate = candidate.replace(/validation$/i, '');
        candidate = candidate.replace(/verification$/i, '');
        candidate = candidate.replace(/verify$/i, '');
        candidate = candidate.replace(/[-_.]+token$/, '');
        candidate = candidate.replace(/[-_.]+$/, '');
        candidate = candidate.replace(/^proof-/, '');
        if (!candidate || candidate.length < 3) return null;
        if (!/[a-z]/i.test(candidate)) return null;
        if (/^[0-9a-f-]{8,}$/i.test(candidate)) return null;
        if (/^[0-9a-z]{12,}$/i.test(candidate) && !/[aeiou]/i.test(candidate)) return null;
        if (!/^[a-z0-9]+(?:[-_.][a-z0-9]+)*$/i.test(candidate)) return null;
        if (['domain', 'site', 'verification', 'validation', 'verify', 'challenge', 'proof'].includes(candidate)) {
          return null;
        }
        return titleizeSignalLabel(candidate);
      };
      const recordTxtProviderMatches = (value) => {
        const displayValue = String(value || '')
          .replace(/\\u003d/g, '=')
          .replace(/"/g, '')
          .trim();
        const normalized = displayValue
          .toLowerCase()
          .trim();
        if (!normalized) return;
        const matchedLabels = new Set();
        txtSignalMatchers.forEach((provider) => {
          if (provider.patterns.some((pattern) => normalized.includes(pattern))) {
            matchedLabels.add(provider.label);
          }
        });
        if (!matchedLabels.size) {
          const inferred = inferGenericTxtSignal(normalized);
          if (inferred) matchedLabels.add(inferred);
        }
        matchedLabels.forEach((label) => {
          txtProviderCounts[label] = (txtProviderCounts[label] || 0) + 1;
          if (label === 'SPF') {
            if (!txtProviderRecords[label]) txtProviderRecords[label] = new Set();
            txtProviderRecords[label].add(displayValue);
          }
        });
      };
      dnsRecords.forEach((record) => {
        if (!record || !record.type) return;
        const type = record.type.toUpperCase();
        if (type === 'CNAME') stats.cnames += 1;
        if (type === 'TXT') {
          stats.txtRecords += 1;
          recordTxtProviderMatches(record.value);
        }
        if (type === 'MX' && record.value) {
          const normalizedMx = normalizeMxValue(record.value);
          if (normalizedMx) mxSet.add(normalizedMx);
        }
      });
      stats.mxHosts = Array.from(mxSet).sort();
      stats.txtVerificationProviders = Object.entries(txtProviderCounts)
        .map(([label, count]) => ({
          label,
          count,
          records: Array.from(txtProviderRecords[label] || []),
        }))
        .sort((a, b) => {
          if (b.count !== a.count) return b.count - a.count;
          return a.label.localeCompare(b.label);
        });
      return stats;
    },
    rawDnsRecords() {
      const rawResponse = this.executiveReport && this.executiveReport.rawResponseData;
      if (!rawResponse) {
        return [];
      }
      const apex = (this.executiveReport.reportInput && this.executiveReport.reportInput[0]) || '';
      const normalizeSubdomain = (subdomain) => {
        if (!subdomain) return null;
        if (!apex || subdomain.includes(apex)) {
          return subdomain;
        }
        return `${subdomain}.${apex}`;
      };
      const subdomains = rawResponse.subdomains
        || (rawResponse.aggregated_result && rawResponse.aggregated_result.subdomains);
      if (Array.isArray(subdomains) && subdomains.length) {
        return subdomains.map(normalizeSubdomain).filter((value) => Boolean(value));
      }
      if (rawResponse.aggregated_result && rawResponse.aggregated_result.dns_records) {
        return rawResponse.aggregated_result.dns_records;
      }
      return [];
    },
    resolvedAttackPathways() {
      if (this.executiveReport
        && this.executiveReport.pastReportDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0]
        && this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved) {
        // eslint-disable-next-line max-len
        const removed = this.executiveReport.pastReportDiff.executiveSummaryDiff[0].iterableItemRemoved;
        const attackPathKeys = Object.keys(removed).filter((key) => key.includes('attackPathwayFindings'));
        return attackPathKeys
          .map((key) => removed[key])
          .filter((pathway) => pathway
            && pathway.attackPathwayRule
            && Array.isArray(pathway.attackPathwayRule.rules));
      }
      return [];
    },
    hostsWithFindingsCount() {
      return this.hosts.filter((host) => host.findings.count).length;
    },
    hostsWithoutFindingsCount() {
      return this.hosts.length - this.hostsWithFindingsCount;
    },
    filteredHosts() {
      let tempHosts = [];

      switch (this.findingsFilter) {
        case 'Findings':
          tempHosts = this.hosts.filter((host) => host.findings.count);
          break;
        case 'No Findings':
          tempHosts = this.hosts.filter((host) => !host.findings.count);
          break;
        case 'Screenshots':
          tempHosts = [];
          break;
        default:
          tempHosts = this.hosts;
      }

      if (this.filteredFindings.length) {
        // eslint-disable-next-line max-len
        tempHosts = tempHosts.filter((host) => host.findings.rules.some((rule) => this.filteredFindings.includes(rule)));
      }

      if (this.filteredTechnologies.length) {
        // eslint-disable-next-line max-len
        tempHosts = tempHosts.filter((host) => host.technologies && host.technologies.some((tech) => this.filteredTechnologies.includes(tech.description)));
      }

      if (this.findingsFilter === 'All' || this.findingsFilter === 'No Findings') {
        const countPorts = (host) => (Array.isArray(host.ports) ? host.ports.length : 0);
        tempHosts = [...tempHosts].sort((a, b) => {
          const findingsDifference = Number(Boolean(b.findings.count))
            - Number(Boolean(a.findings.count));
          if (findingsDifference) return findingsDifference;
          return countPorts(b) - countPorts(a);
        });
      }

      return tempHosts;
    },
    paginatedFilteredHosts() {
      return [...this.filteredHosts.slice(0, (this.page + 1) * 100)];
    },
    maxPageSizeHosts() {
      return Math.ceil(this.filteredHosts.length / 100);
    },
    removedHosts() {
      const currentHostIPs = this.hosts.map((host) => host.ip);
      return this.pastHosts.filter((pastHost) => !currentHostIPs.includes(pastHost.ip));
    },
    credentialsCount() {
      return (this.executiveReport.summary
        && this.executiveReport.summary.leakedCredentialsSummary
        && Object.keys(this.executiveReport.summary.leakedCredentialsSummary).reduce(
          (a, b) => a + this.executiveReport.summary.leakedCredentialsSummary[b], 0,
        )
      )
      || 0;
    },
    credentialsCritical() {
      return this.executiveReport.summary
             && this.executiveReport.summary.leakedCredentials
             && this.executiveReport.summary.leakedCredentials
               .filter((cred) => cred.severity === 2);
    },
    credentialsMedium() {
      return this.executiveReport.summary
        && this.executiveReport.summary.leakedCredentials
        && this.executiveReport.summary.leakedCredentials
          .filter((cred) => cred.severity === 1);
    },
    credentialsLow() {
      return this.executiveReport.summary
        && this.executiveReport.summary.leakedCredentials
        && this.executiveReport.summary.leakedCredentials
          .filter((cred) => cred.severity === 0);
    },
    orderedReportScreenshots() {
      return this.reportScreenshots
        .map((screenshot) => ({ screenshot, sortKey: this.screenshotSortKey(screenshot) }))
        .sort((left, right) => left.sortKey.localeCompare(right.sortKey))
        .map(({ screenshot }) => screenshot);
    },
    screenshots() {
      if (this.findingsFilter !== 'Screenshots') return [];

      return this.orderedReportScreenshots.slice(0, (this.screenShotPage + 1) * 20);
    },
    pageReadyToDisplay() {
      return !!((!this.isLoading && !this.pendingRequestCount) && this.isCompleted);
    },
  },
  methods: {
    ...mapActions(['fetchReport', 'fetchPastReport', 'fetchPastReportScreenshots',
      'fetchReportScreenshots', 'requestDirectoryEnumeration', 'updateRequestDirectoryEnumerationStatus',
      'fetchReportAsync', 'fetchReportScreenshotsAsync', 'fetchPrices']),
    async showSubscriptionOptions() {
      await this.fetchPrices();
    },
    resetData() {
      this.pollingCount = 0;
      clearTimeout(this.pollingTimeout);
      this.pollingTimeout = null;
      this.hosts = [];
      this.pastHosts = [];
      this.dnsMailProvidersOverflowing = false;
    },
    scheduleReportRetry() {
      clearTimeout(this.pollingTimeout);
      this.pollingTimeout = setTimeout(() => this.loadCurrentReport(), 10000);
    },
    async loadCurrentReport() {
      const reportID = this.currentReportID;
      if (!reportID) return false;

      const reportLoaded = await this.fetchReportAsync(reportID);
      if (String(reportID) !== String(this.currentReportID)) return false;

      if (!reportLoaded) {
        if (this.executiveReportLoadStatus === 'unavailable') {
          this.scheduleReportRetry();
        }
        return false;
      }

      // A child report must belong to the executive report in the current route.
      if (!this.isCurrentReport || (this.executiveReport.parentReportID
          && this.executiveReport.parentReportID !== this.parentReportID)) {
        this.$router.replace({
          name: 'executive-report',
          params: {
            // eslint-disable-next-line max-len
            execReport: this.$route.params.execReport || this.executiveReport.parentReportID,
          },
        });
        return false;
      }

      if (this.isInFlight) {
        this.showExecutiveProgress();
        return true;
      }

      await this.fetchReportScreenshotsAsync(reportID);
      if (String(reportID) !== String(this.currentReportID)) return false;

      if (this.isCompleted) {
        this.hosts = [];
        this.populateHosts(this.executiveReport.aggregatedResult);
        if (this.pastReportID) {
          const pastReportLoaded = await this.fetchPastReport(this.pastReportID);
          if (pastReportLoaded) {
            await this.fetchPastReportScreenshots(this.pastReportID);
            this.getRemovedHosts();
          }
        }
      }

      this.setFindingFilters();
      this.updateDnsMailProvidersOverflowState();
      return true;
    },
    loadMore() {
      if ((this.page + 1) * 100 < this.filteredHosts.length) {
        this.page += 1;
      }
    },
    loadMoreScreenshots() {
      this.screenShotPage += 1;
    },
    createObserver() {
      if (this.observer) this.observer.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.loadMore();
        }
      });
      const element = this.$refs.observed;
      if (element) this.observer.observe(element);
    },
    createScreenshotObserver() {
      if (this.screenShotObserver) this.screenShotObserver.disconnect();
      this.screenShotObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.loadMoreScreenshots();
        }
      });
      const element = this.$refs.screenshotObserved;
      if (element) this.screenShotObserver.observe(element);
    },
    updateDnsMailProvidersOverflowState() {
      this.$nextTick(() => {
        const element = this.$refs.mailProvidersScrollArea;
        if (!element) {
          this.dnsMailProvidersOverflowing = false;
          return;
        }
        this.dnsMailProvidersOverflowing = element.scrollHeight > (element.clientHeight + 1);
      });
    },
    renderCorrectExpandElement(value) {
      return value ? '-' : '+';
    },
    showOrHideByValue(value) {
      return value ? 'Hide' : 'Show';
    },
    screenshotAltText(screenshot) {
      if (screenshot.ipAddress && screenshot.port) {
        return `Screenshot of ${screenshot.ipAddress}:${screenshot.port}`;
      }

      if (screenshot.domainName) {
        return `Screenshot of ${screenshot.domainName}`;
      }
      return `Screenshot of ${this.executiveReport.reportInput[0]}`;
    },
    screenshotSortKey(screenshot) {
      const ip = (screenshot.ipAddress || '')
        .split('.')
        .map((octet) => octet.padStart(3, '0'))
        .join('.');
      const port = String(screenshot.port || '').padStart(5, '0');
      return `${ip}|${screenshot.domainName || ''}|${port}|${screenshot.source || ''}`;
    },
    hostAnchorId(host) {
      return `host-${String(host.ip || 'unknown').replace(/[^A-Za-z0-9_-]/g, '-')}`;
    },
    hostFilterForNavigation(hostIp) {
      const preferredFilter = this.previousFindingsFilter || 'Findings';
      const host = this.hosts.find((candidate) => candidate.ip === hostIp);
      const findingsCount = host && host.findings ? host.findings.count : 0;

      if (!host
        || (preferredFilter === 'Findings' && !findingsCount)
        || (preferredFilter === 'No Findings' && findingsCount)) {
        return 'All';
      }

      return preferredFilter;
    },
    screenshotAnchorId(screenshot) {
      const fileName = (screenshot.file || '')
        .split('?')[0]
        .split('/')
        .pop();
      const fallback = `${screenshot.ipAddress || 'host'}-${screenshot.port || 'port'}-${screenshot.domainName || 'ip'}`;
      const identity = [
        screenshot.ipAddress || 'host',
        screenshot.port || 'port',
        screenshot.domainName || screenshot.source || 'ip',
        fileName || fallback,
      ].join('-');
      return `screenshot-${identity.replace(/[^A-Za-z0-9_-]/g, '-')}`;
    },
    screenshotCardClass(screenshot) {
      if (this.activeScreenshotHostIp && screenshot.ipAddress === this.activeScreenshotHostIp) {
        return [
          'screenshot-card--active',
          'border-yellow-500',
          'bg-yellow-900',
          'bg-opacity-25',
          'shadow-glowyellow',
        ].join(' ');
      }

      return 'border-gray-600 bg-gray-800';
    },
    teardownActiveScreenshotVisibilityObserver() {
      if (this.activeScreenshotVisibilityObserver) {
        this.activeScreenshotVisibilityObserver.disconnect();
        this.activeScreenshotVisibilityObserver = null;
      }
      if (this.activeScreenshotVisibilityHandler) {
        window.removeEventListener('scroll', this.activeScreenshotVisibilityHandler);
        window.removeEventListener('resize', this.activeScreenshotVisibilityHandler);
        this.activeScreenshotVisibilityHandler = null;
      }
    },
    setupActiveScreenshotVisibilityObserver() {
      this.teardownActiveScreenshotVisibilityObserver();
      this.$nextTick(() => {
        const updateVisibility = () => {
          const container = this.$refs.screenShotContainer;
          if (!container) {
            this.activeScreenshotGroupVisible = false;
            return;
          }

          const elements = Array.from(container.querySelectorAll('.screenshot-card--active'));
          if (!elements.length) {
            this.activeScreenshotGroupVisible = false;
            return;
          }

          const bounds = elements.reduce((memo, element) => {
            const rect = element.getBoundingClientRect();
            return {
              top: Math.min(memo.top, rect.top),
              bottom: Math.max(memo.bottom, rect.bottom),
            };
          }, { top: Number.POSITIVE_INFINITY, bottom: Number.NEGATIVE_INFINITY });
          this.activeScreenshotGroupVisible = bounds.bottom > 0 && bounds.top < window.innerHeight;
        };

        this.activeScreenshotVisibilityHandler = updateVisibility;
        window.addEventListener('scroll', updateVisibility, { passive: true });
        window.addEventListener('resize', updateVisibility);
        updateVisibility();
      });
    },
    scrollToScreenshot(screenshot) {
      const scroll = () => {
        const element = document.getElementById(this.screenshotAnchorId(screenshot));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(scroll);
        });
        window.setTimeout(scroll, 400);
        window.setTimeout(scroll, 1200);
      });
    },
    showPortScreenshots(payload) {
      if (!payload) return;
      const portScreenshots = Array.isArray(payload) ? payload : payload.screenshots;
      const target = portScreenshots && portScreenshots[0];
      if (!target) return;

      this.previousFindingsFilter = this.findingsFilter === 'Screenshots'
        ? this.previousFindingsFilter
        : this.findingsFilter;
      this.activeScreenshotHostIp = payload.hostIp || target.ipAddress || null;
      this.activeScreenshotTargetLabel = payload.targetLabel || target.domainName || null;
      this.highlightedHostIp = null;

      const targetIndex = this.orderedReportScreenshots
        .findIndex((screenshot) => screenshot.file === target.file);
      if (targetIndex >= 0) {
        this.screenShotPage = Math.max(this.screenShotPage, Math.floor(targetIndex / 20));
      }
      this.findingsFilter = 'Screenshots';
      this.scrollToScreenshot(target);
      this.setupActiveScreenshotVisibilityObserver();
    },
    returnToActiveScreenshotHost() {
      const hostIp = this.activeScreenshotHostIp;
      if (!hostIp) return;

      this.findingsFilter = this.previousFindingsFilter || 'Findings';
      this.expandAll = true;
      this.highlightedHostIp = hostIp;
      this.$nextTick(() => {
        const element = document.getElementById(this.hostAnchorId({ ip: hostIp }));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.activeScreenshotHostIp = null;
        this.activeScreenshotTargetLabel = null;
        this.activeScreenshotGroupVisible = false;
        this.teardownActiveScreenshotVisibilityObserver();
      });
    },
    screenshotCaptionHasSelection(event) {
      if (!event || !event.currentTarget || !window.getSelection) return false;

      const selection = window.getSelection();
      if (!selection || selection.isCollapsed || !selection.rangeCount
          || !selection.toString().trim()) return false;

      return event.currentTarget.contains(selection.getRangeAt(0).commonAncestorContainer);
    },
    selectScreenshotCaption(caption) {
      if (!caption || !window.getSelection) return;

      const selection = window.getSelection();
      if (!selection) return;

      const range = document.createRange();
      range.selectNodeContents(caption);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    beginScreenshotCaptionSelection(event) {
      if (!event || !event.currentTarget) return;
      if (this.screenshotCaptionSelectionCleanup) {
        this.screenshotCaptionSelectionCleanup();
      }

      const caption = event.currentTarget.querySelector('.screenshot-caption-text');
      if (!caption) return;

      const startX = event.clientX;
      const startY = event.clientY;
      let isDragging = false;
      const continueSelection = (moveEvent) => {
        if (!isDragging) {
          const horizontalDistance = Math.abs(moveEvent.clientX - startX);
          const verticalDistance = Math.abs(moveEvent.clientY - startY);
          isDragging = horizontalDistance > 3 || verticalDistance > 3;
        }
        if (!isDragging) return;

        moveEvent.preventDefault();
        this.selectScreenshotCaption(caption);
      };
      let finishSelection;
      const cleanup = () => {
        window.removeEventListener('mousemove', continueSelection);
        window.removeEventListener('mouseup', finishSelection);
        window.removeEventListener('blur', cleanup);
        if (this.screenshotCaptionSelectionCleanup === cleanup) {
          this.screenshotCaptionSelectionCleanup = null;
        }
      };
      finishSelection = () => {
        if (isDragging) this.selectScreenshotCaption(caption);
        window.setTimeout(cleanup, 0);
      };

      event.preventDefault();
      this.screenshotCaptionSelectionCleanup = cleanup;
      window.addEventListener('mousemove', continueSelection);
      window.addEventListener('mouseup', finishSelection, { once: true });
      window.addEventListener('blur', cleanup, { once: true });
    },
    showHostFromScreenshot(screenshot, event) {
      if (this.screenshotCaptionHasSelection(event)) return;
      if (!screenshot || !screenshot.ipAddress) return;

      const hostIp = screenshot.ipAddress;
      this.findingsFilter = this.hostFilterForNavigation(hostIp);
      this.expandAll = true;
      this.highlightedHostIp = hostIp;
      this.activeScreenshotHostIp = null;
      this.activeScreenshotTargetLabel = null;
      this.activeScreenshotGroupVisible = false;
      this.teardownActiveScreenshotVisibilityObserver();
      this.$nextTick(() => {
        const targetIndex = this.filteredHosts.findIndex((host) => host.ip === hostIp);
        if (targetIndex > -1) {
          this.page = Math.max(this.page, Math.floor(targetIndex / 100));
        }

        this.$nextTick(() => {
          const element = document.getElementById(this.hostAnchorId({ ip: hostIp }));
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    },
    populateHosts(data, isPastReport = false) {
      const findingsByIp = new Map();
      const technologiesByIp = new Map();

      (data.findings || []).forEach((finding) => {
        if (!findingsByIp.has(finding.ipAddress)) {
          findingsByIp.set(finding.ipAddress, []);
        }
        findingsByIp.get(finding.ipAddress).push(finding.rule.outcome);
      });

      (data.technologies || []).forEach((technology) => {
        if (!technologiesByIp.has(technology.ipAddress)) {
          technologiesByIp.set(technology.ipAddress, []);
        }
        technologiesByIp.get(technology.ipAddress).push(technology);
      });

      const hosts = (data.ips || []).map((host) => {
        const {
          ip,
          category,
          categoryExplanation,
          country,
          asn,
          org,
          subdomains,
          ports,
        } = host;
        const findingRules = findingsByIp.get(ip) || [];

        return {
          ip,
          category,
          categoryExplanation,
          country,
          asn,
          org,
          subdomains: subdomains || [],
          technologies: technologiesByIp.get(ip) || [],
          ports: (ports || []).map((port) => ({
            ...port,
            screenshots: [],
          })),
          screenshots: [],
          findings: {
            count: findingRules.length,
            rules: findingRules,
          },
        };
      });

      this.populateHostScreenshots(
        hosts,
        isPastReport ? this.pastScreenshots : this.reportScreenshots,
        this.executiveReport.reportInput[0],
      );

      if (isPastReport) {
        this.pastHosts = hosts;
      } else {
        this.hosts = hosts;
      }

      // if user is a trial user we should check to see if this should be surfaced or not
      // this host should be in the current host list or in
      // the removed host list on the execsummary diff
      if (this.currentUser.organization.isTrial) {
        const currentIpList = this.executiveReport.aggregatedResult.ips.map((ip) => ip.ip);
        let ipsDiff = [];
        if (this.executiveReport.pastReportDiff && this.executiveReport.pastReportDiff.ipsDiff) {
          ipsDiff = this.executiveReport.pastReportDiff.ipsDiff;
        }
        const ipsInDiff = ipsDiff.map((entry) => entry.ip);
        this.pastHosts = this.pastHosts.filter(
          (h) => currentIpList.includes(h.ip) || ipsInDiff.includes(h.ip),
        );
      }
    },
    populateHostScreenshots(hosts, screenshots, rootDomain) {
      const hostsByIp = new Map();

      hosts.forEach((host) => {
        const portsById = new Map();
        host.ports.forEach((port) => {
          const portId = String(port.portid);
          if (!portsById.has(portId)) portsById.set(portId, []);
          portsById.get(portId).push(port);
        });
        hostsByIp.set(host.ip, {
          host,
          portsById,
          domainScreenshots: new Map(),
        });
      });

      const screenshotFilesByPort = new WeakMap();
      const appendPortScreenshot = (port, screenshot) => {
        let screenshotFiles = screenshotFilesByPort.get(port);
        if (!screenshotFiles) {
          screenshotFiles = new Set();
          screenshotFilesByPort.set(port, screenshotFiles);
        }
        if (screenshotFiles.has(screenshot.file)) return;
        screenshotFiles.add(screenshot.file);
        port.screenshot = port.screenshot || screenshot.file;
        port.screenshots.push(screenshot);
      };

      (screenshots || []).forEach((screenshot) => {
        const indexedHost = hostsByIp.get(screenshot.ipAddress);
        if (!indexedHost) return;

        const matchingPorts = indexedHost.portsById.get(String(screenshot.port)) || [];
        matchingPorts.forEach((port) => appendPortScreenshot(port, screenshot));

        if (screenshot.source && screenshot.source.includes('domain-name')) {
          const hostname = this.screenshotHostname(screenshot.domainName);
          if (hostname && !indexedHost.domainScreenshots.has(hostname)) {
            indexedHost.domainScreenshots.set(hostname, screenshot);
          }
        }
      });

      hostsByIp.forEach(({ host, domainScreenshots }) => {
        host.screenshots = host.subdomains
          .map((subdomain) => domainScreenshots.get(`${subdomain}.${rootDomain}`.toLowerCase()))
          .filter((screenshot) => Boolean(screenshot));
        host.ports.forEach((port) => {
          port.screenshots = Object.freeze(port.screenshots);
        });
        host.screenshots = Object.freeze(host.screenshots);
      });
    },
    getRemovedHosts() {
      if (this.pastReport) {
        this.populateHosts(this.pastReport.aggregatedResult, true);
      }
      return [];
    },
    handleRecollated() {
      this.handleClose();
      this.showExecutiveProgress();
    },
    showExecutiveProgress() {
      return this.$router.replace({
        name: 'executive-report',
        params: { execReport: this.parentReportID },
      });
    },
    handleClose(redirectRoute, shouldFetchReport = false) {
      this.showAdminModal = false;
      if (redirectRoute) {
        this.$router.push({ name: redirectRoute });
      }
      if (shouldFetchReport) {
        this.fetchReport(this.currentReportID);
        this.fetchReportScreenshots(this.currentReportID);
      }
    },
    async handleDownloadCsv() {
      const response = await api.get(`reports/${this.currentReportID}/csv`, { responseType: 'blob' });
      const href = URL.createObjectURL(response.data.rawResponseData);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `report-${this.currentReportID}.csv`); // or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },
    handleDownloadLeakedCredsCsv() {
      const leakedCreds = (this.executiveReport && this.executiveReport.summary
        && this.executiveReport.summary.leakedCredentials) || [];
      const escapeCsv = (value) => {
        if (value === null || value === undefined) return '';
        return `"${String(value).replace(/"/g, '""')}"`;
      };
      const resolveCredentialIdentifier = (cred) => cred.email || cred.username || '';
      const resolveCredentialHash = (cred) => cred.hash
        || cred.passwordHash
        || cred.password_hash
        || cred.hashedPassword
        || cred.hashed_password
        || '';
      const classifyCredential = (cred) => {
        if (cred.password) {
          return 0;
        }

        if (resolveCredentialHash(cred)) {
          return 1;
        }

        return 2;
      };
      const resolveCredentialSecret = (cred) => {
        if (cred.password) {
          return cred.password;
        }

        return resolveCredentialHash(cred) || '***';
      };
      const rows = leakedCreds
        .slice()
        .sort((a, b) => classifyCredential(a) - classifyCredential(b))
        .map((cred) => [
          resolveCredentialIdentifier(cred),
          resolveCredentialSecret(cred),
        ]);
      const csv = [
        ['email', 'password'],
        ...rows,
      ].map((row) => row.map(escapeCsv).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const href = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `report-${this.currentReportID}-leaked-creds.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },
    expandAllHosts() {
      this.page = this.maxPageSizeHosts;
      this.expandAll = true;
      window.setTimeout(() => { this.expandAll = null; }, 100);
    },
    collapseAllHosts() {
      this.expandAll = false;
      window.setTimeout(() => { this.expandAll = null; }, 100);
    },
    setFindingFilters() {
      if (this.filterFindingEvent && this.filterFindingEvent.payload) {
        this.filteredFindings.push(this.filterFindingEvent.payload);
        this.$store.commit('UPDATE_FILTER_FINDING_EVENT', '');
        if (this.isLoading) {
          this.shouldScrollToHosts = true;
        } else {
          this.scrollToHosts();
        }
      }
    },
    scrollToHosts() {
      this.$nextTick(() => {
        this.$refs.hostsSection.scrollIntoView({ behavior: 'smooth', alignToTop: true });
        this.shouldScrollToHosts = false;
      });
    },
    screenshotHostname(domainName) {
      if (!domainName) return '';
      try {
        return new URL(domainName).hostname.toLowerCase();
      } catch (error) {
        return domainName
          .replace(/^[a-z]+:\/\//i, '')
          .split('/')[0]
          .split(':')[0]
          .toLowerCase();
      }
    },
    updateDirEnumTargets(target) {
      if (!this.targetsForDictEnum.includes(target)) {
        this.targetsForDictEnum.push(target);
      } else {
        this.targetsForDictEnum = this.targetsForDictEnum.filter((value) => value !== target);
      }
    },
    addTargetForDictEnum(host) {
      if (!this.targetsForDictEnum.includes(host)) this.targetsForDictEnum.push(host);
    },
    removeTargetFromDictEnum(host) {
      const { targetsForDictEnum } = this;
      if (targetsForDictEnum.includes(host)) {
        this.targetsForDictEnum = targetsForDictEnum.filter((value) => value !== host);
      }
    },
    clearHostsForDictEnum() {
      this.targetsForDictEnum = [];
    },
    requestDictEnum() {
      const report = this.currentReportID;
      const hosts = this.targetsForDictEnum;
      this.requestDirectoryEnumeration({ hosts, report }).then(() => {
        this.clearHostsForDictEnum();
      });
    },
  },
  watch: {
    async $route() {
      this.resetData();
      await this.loadCurrentReport();
    },
    pageReadyToDisplay(ready) {
      if (ready) {
        this.$nextTick(() => {
          this.createObserver();
          this.updateDnsMailProvidersOverflowState();
        });
      }
    },
    findingsFilter(filter) {
      if (filter === 'Screenshots') {
        this.$nextTick(() => {
          this.createScreenshotObserver();
        });
      }
    },
    pastReport() {
      this.getRemovedHosts();
    },
    filterFindingEvent() {
      this.setFindingFilters();
    },
    pendingRequestCount(count) {
      if (this.shouldScrollToHosts && !this.isLoading && !count) {
        this.scrollToHosts();
      }
      if (!count) {
        this.updateDnsMailProvidersOverflowState();
      }
    },
    targetsForDictEnum() {
      if (this.targetsForDictEnum && this.targetsForDictEnum.length) {
        this.updateRequestDirectoryEnumerationStatus(null);
      }
    },
  },
};
</script>

<style scoped>
.background {
  @apply max-w-screen-lg w-full h-full;
  animation: spin 120s linear infinite;
  transform-origin: center center;
}

.dns-signal-list {
  columns: 1;
  column-gap: 2rem;
}

.dns-intel-metrics {
  border-bottom: 1px solid #535056;
}

.dns-signal-scroll-shell {
  position: relative;
}

.dns-signal-scroll-shell--active::before,
.dns-signal-scroll-shell--active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0.9rem;
  height: 1rem;
  pointer-events: none;
  z-index: 2;
}

.dns-signal-scroll-shell--active::before {
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(249, 194, 46, 0.3) 0%,
    rgba(249, 194, 46, 0.12) 35%,
    rgba(17, 24, 39, 0) 100%
  );
}

.dns-signal-scroll-shell--active::after {
  bottom: 0;
  background: linear-gradient(
    0deg,
    rgba(249, 194, 46, 0.3) 0%,
    rgba(249, 194, 46, 0.12) 35%,
    rgba(17, 24, 39, 0) 100%
  );
}

.dns-signal-scroll-area {
  max-height: 18rem;
  padding-right: 0.5rem;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: rgba(156, 163, 175, 0.85) rgba(31, 41, 55, 0.9);
}

.dns-signal-scroll-area--mail {
  padding-right: 0.5rem;
}

.screenshot-image-frame {
  position: relative;
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 62.5%;
  overflow: hidden;
  background: #000;
}

.screenshot-image-frame img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.screenshot-caption-button {
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  overflow-wrap: inherit;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  user-select: text;
  -moz-user-select: text;
}

.screenshot-caption-button:hover,
.screenshot-caption-button:focus {
  color: #F9C22E;
}

.screenshot-return-button {
  position: fixed;
  right: 1.25rem;
  top: 50%;
  z-index: 50;
  transform: translateY(-50%);
  box-shadow: 0 0 6px 0 #F9C22E;
}

@media (max-width: 767px) {
  .screenshot-return-button {
    top: 72%;
    right: 0.5rem;
    padding: 0.5rem 0.625rem;
    font-size: 0.6875rem;
    line-height: 1rem;
  }

  .screenshot-return-icon {
    width: 0.75rem;
    height: 0.75rem;
  }

  .screenshot-return-detail {
    font-size: 0.625rem;
    line-height: 0.75rem;
  }
}

@media (min-width: 1280px) {
  .screenshot-return-button {
    left: 66.666vw;
    right: auto;
    transform: translate(-50%, -50%);
  }
}

.dns-signal-scroll-area::-webkit-scrollbar {
  width: 0.75rem;
}

.dns-signal-scroll-area::-webkit-scrollbar-track {
  background: rgba(31, 41, 55, 0.9);
  border-left: 1px solid rgba(75, 85, 99, 0.75);
}

.dns-signal-scroll-area::-webkit-scrollbar-thumb {
  background: rgba(156, 163, 175, 0.85);
  border-radius: 9999px;
  border: 2px solid rgba(31, 41, 55, 0.9);
}

.dns-signal-scroll-area::-webkit-scrollbar-thumb:hover {
  background: rgba(209, 213, 219, 0.95);
}

.dns-signal-list > li {
  break-inside: avoid;
}

@media (min-width: 1280px) {
  .dns-signal-list--tags {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 2rem;
  }

  .dns-signal-provider--detailed {
    grid-column: 1 / -1;
  }
}

.triangle::before {
  @apply absolute border-b bg-gray-900 border-t border-gray-600 border-r z-0
  transform skew-x-20;
  top: -1px;
  left: calc(100% - 0.75rem);
  width: calc(1rem + 12px);
  height: calc(100% + 2px);
  content: '';
}

.export-creds-chip {
  @apply transition-colors duration-150 ease-linear;
}

.export-creds-chip:hover,
.export-creds-chip:focus {
  @apply bg-yellow-900;
}

.export-creds-chip:hover::before,
.export-creds-chip:focus::before {
  @apply bg-yellow-900;
}

.export-creds-chip:hover span,
.export-creds-chip:focus span {
  @apply text-gray-200;
}

.page-break {
  page-break-before: always;
}

.background-wrapper--step2 {
  transform: translate(-10%, 10%) scale(0.6);
}

.header-wrapper {
  max-height: 3rem !important;
}
</style>
